import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo } from 'react';
import { useDeepCompareMemo } from 'use-deep-compare';

import { COLOR } from '../../theme/type';
import { colorToCss } from '../../theme/utils';
import { StyledRouteButton } from './styled';
import { RouteProps } from './type';

type RouteButtonProps = RouteProps & {
  background?: COLOR;
  bold?: boolean;
  color?: COLOR;
};

const RouteButton: FC<RouteButtonProps> = ({
  background = COLOR.Highlight,
  bold = false,
  color = COLOR.White,
  sx,
  ...props
}) => {
  const sxButton = useDeepCompareMemo<SxProps<Theme>>(
    () => ({
      ...sx,
      backgroundColor: colorToCss(background),
      color: colorToCss(color),
      fontWeight: bold ? 'bold' : undefined,
    }),
    [sx, background, color, bold]
  );

  return <StyledRouteButton sx={sxButton} {...props} />;
};

export default memo(RouteButton);
